<template>
    <div>
        <b-card v-if="followUpCases && followUpCases.length" header="Pending doctor follow-up cases."
            border-variant="info" header-bg-variant="info" header-text-variant="white">
            <b-card-text>
                There are pending follow-up cases open for this patient. Check follow-up queue clicking
                <b>
                    <router-link :to="{ name: 'DoctorFollowUpQueue' }">Here</router-link>
                </b>
            </b-card-text>
            <div v-for="c in followUpCases" class="alert alert-primary" role="alert" :key="c.id">
                <span v-if="c.type == faxTypeEnum.NewRxRequest"><b>{{ c.requestName }}</b> for drug {{ c.drugName }}.
                </span>
                <span v-else><b>{{ c.requestName }}</b> for prescription {{ c.rxID }}. </span>
                <a href="#" @click.prevent="openDetails(c)" style="color:white !important"><b>See Details</b></a>
            </div>
        </b-card>

        <!-- Follow-up case details -->
        <b-modal :id="caseModalId" title="Doctor Follow-Up Case" size="xl" hide-footer static
            @hidden="resetSelectedCase">
            <!-- FOLLOW UP COMPONENT -->
            <DoctorFollowUpCaseForm v-if="selectedCase && selectedCase.id" v-model="selectedCase"
                @submitted="closeCaseModalAndReload" />
        </b-modal>

    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { PrescriberFollowUpCase, FaxType, PrescriberFollowUpStatus } from '@/models/PrescriberFollowUpCase';
import DoctorFollowUpCaseForm from '@/components/Doctor/DoctorFollowUpCaseForm.vue';
import { NotificationOptions } from '@/util/NotificationOptionsPresets';

@Component({
    name: "DoctorFollowUpCasesAlertComponent",
    components: { DoctorFollowUpCaseForm }
})
export default class DoctorFollowUpCasesAlertComponent extends Vue {
    @Prop() public patientId!: number;
    @Prop({ default: 'followup-case-form' }) private caseModalId!: string;

    @Prop({ default: () => [] }) public followUpCasesProvided!: Array<PrescriberFollowUpCase>;
    @Prop({ default: false }) public willProvideFollowUpCases!: boolean;
    protected faxTypeEnum = FaxType;

    protected followUpCases: Array<PrescriberFollowUpCase> = []

    private selectedCase: PrescriberFollowUpCase = new PrescriberFollowUpCase();

    created() {
        this.fetchFollowUpCases();
    }

    @Watch('patientId') changedPatient() {
        this.followUpCases = [];
        this.fetchFollowUpCases();
    }

    @Watch('followUpCasesProvided') changedFollowUpCases() {
        if (this.willProvideFollowUpCases) {
            this.followUpCases = this.followUpCasesProvided;
        }
    }

    fetchFollowUpCases() {
        if (this.willProvideFollowUpCases) {
            this.followUpCases = this.followUpCasesProvided;
            return;
        }
        if (!this.patientId) return;
        //Check if there are pending follow up cases
        this.$http.get<Array<PrescriberFollowUpCase>>(`/prescriber/follow-up-by-patient/${this.patientId}`)
            .then(res => {
                if (res.data?.length)
                    this.followUpCases = res.data.filter(c => c.status == PrescriberFollowUpStatus.Created || c.status == PrescriberFollowUpStatus.InProgress)
                        .map(c => new PrescriberFollowUpCase(c));
            })
            .catch(err => {
                console.error('Error while getting doctor follow-up cases by patient.', {
                    err,
                    response: err?.response
                });
                this.$notification(NotificationOptions.error(err));
            });
    }

    openDetails(selectedItem: PrescriberFollowUpCase) {
        this.selectedCase = selectedItem;
        this.$bvModal.show(this.caseModalId);
    }

    // Clearing the case tears the form down via its v-if, releasing the case lock
    // through the form's LockHandler teardown.
    resetSelectedCase() {
        this.selectedCase = new PrescriberFollowUpCase();
    }

    closeCaseModalAndReload() {
        this.$bvModal.hide(this.caseModalId);
        this.fetchFollowUpCases();
    }
}

</script>

<style scoped></style>
